import { render, staticRenderFns } from "./CnDetailSds.vue?vue&type=template&id=5469ef20&scoped=true&"
import script from "./CnDetailSds.vue?vue&type=script&lang=js&"
export * from "./CnDetailSds.vue?vue&type=script&lang=js&"
import style0 from "./CnDetailSds.vue?vue&type=style&index=0&id=5469ef20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469ef20",
  null
  
)

export default component.exports